import PropTypes from 'prop-types';
import React from 'react';

export default function SignIn({ textColor, ...props }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.4853 3.51473C18.2188 1.24823 15.2053 0 12 0C8.79469 0 5.78123 1.24823 3.51469 3.51473C1.24823 5.78123 0 8.79469 0 12C0 15.2053 1.24823 18.2188 3.51469 20.4853C5.78123 22.7518 8.79469 24 12 24C15.2053 24 18.2188 22.7518 20.4853 20.4853C22.7518 18.2188 24 15.2053 24 12C24 8.79469 22.7518 5.78123 20.4853 3.51473ZM12 22.5938C8.86552 22.5938 6.04514 21.2249 4.10381 19.0542C5.30733 15.8635 8.38819 13.5938 12 13.5938C9.67003 13.5938 7.78125 11.705 7.78125 9.375C7.78125 7.04503 9.67003 5.15625 12 5.15625C14.33 5.15625 16.2188 7.04503 16.2188 9.375C16.2188 11.705 14.33 13.5938 12 13.5938C15.6118 13.5938 18.6927 15.8635 19.8962 19.0542C17.9549 21.2249 15.1345 22.5938 12 22.5938Z"
        fill={textColor}
      />
    </svg>
  );
}

SignIn.propTypes = {
  textColor: PropTypes.string.isRequired
};
